'use es6';

import { Record, Set as ImmutableSet } from 'immutable';
export const UserKeys = {
  USER_ID: 'user_id',
  EMAIL: 'email',
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  LOCALE: 'locale',
  LANG_ENABLED: 'lang_enabled',
  SCOPES: 'scopes',
  SIDEKICK_USER_ID: 'sidekick_user_id',
  ROLES: 'roles',
  PARTNER: 'partner',
  ACTING_USER_ID: 'acting_user_id',
  TEAMS: 'teams',
  EMAILS: 'emails',
  CREATED_AT: 'created_at'
};
export default class User extends Record({
  [UserKeys.USER_ID]: 0,
  [UserKeys.EMAIL]: '',
  [UserKeys.FIRST_NAME]: '',
  [UserKeys.LAST_NAME]: '',
  [UserKeys.LOCALE]: 'en',
  [UserKeys.LANG_ENABLED]: false,
  [UserKeys.SCOPES]: new ImmutableSet(),
  [UserKeys.SIDEKICK_USER_ID]: 0,
  [UserKeys.ROLES]: [],
  [UserKeys.PARTNER]: false,
  [UserKeys.ACTING_USER_ID]: 0,
  [UserKeys.TEAMS]: [],
  [UserKeys.EMAILS]: [],
  [UserKeys.CREATED_AT]: 0
}) {}